import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";


export const useMachine = create()(
  persist(
    (set) => ({
      machineSelected: null,
      addressMachine: null,
      machine: null,
      nameEmpresa: null,
      empresa_id : null,
      logoMachine: null,
      setMachine: (maquina) => {
        set(() => {
          const machineMap = {
            comuna_nombre: maquina.comuna_nombre,
            region_nombre: maquina.region_nombre,
            empresa_id: maquina.empresa_id,
            empresa_nombre: maquina.empresa_nombre,
            empresa_rut: maquina.empresa_rut,
            maquina_direccion: maquina.maquina_direccion,
            maquina_latitud: maquina.maquina_latitud,
            maquina_longitud: maquina.maquina_longitud,
            maquina_nombre: maquina.maquina_nombre,
            maquinamodelo_icono: maquina.maquinamodelo_icono,
            oneclick_apikey: maquina.oneclick_apikey,
            oneclick_codigo_comercio: maquina.oneclick_codigo_comercio,
            oneclick_codigo_tienda: maquina.oneclick_codigo_tienda,
            webpay_apikey: maquina.webpay_apikey,
            webpay_codigo_comercio: maquina.webpay_codigo_comercio,
            vende_licor: maquina.vende_licor,
            maquina_telefono: maquina.maquina_telefono
          };
          
          return { 
            machineSelected: maquina.maquina_id, 
            addressMachine: maquina.maquina_direccion,
            logoMachine : maquina.maquinamodelo_icono,
            machine: machineMap,
            nameEmpresa: maquina.empresa_nombre,
            empresa_id : maquina.empresa_id
          };
        });
      },
      clearMachine: () => {
        set(() => {
          return {
            machineSelected: null,
            addressMachine: null,
            machine: null,
            nameEmpresa: null,
            logoMachine: null,
            empresa_id: null
          };
        });
      },
      setEmpresaId: (id) => set({ empresa_id: id }),
    }),
    {
      name: "machine-storage", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // 'localStorage','sessionStorage' is used 
    }
  )
);